import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectLogId = createSelector(
  (state) => state.background.logId,
  (logId) => logId
);

export const selectCampaignIdViewCounts = createSelector(
  (state) => state.background.campaignIdViewCounts,
  (campaignIdViewCounts) =>
    campaignIdViewCounts as RootState["background"]["campaignIdViewCounts"]
);

// Select campaignId view counts based on passed campaignId
export const selectCampaignIdViewCount = (campaignId: number) =>
  createSelector(
    selectCampaignIdViewCounts,
    (campaignIdViewCounts) => campaignIdViewCounts?.[campaignId]
  );

export const selectCampaignHideDuration = (campaignId: number) =>
  createSelector(
    (state: RootState) =>
      state.background.campaignIdViewCounts?.[campaignId]?.campaignHideDuration,
    (campaignHideDuration) => campaignHideDuration
  );

export const selectCampaignUniqueViews = (campaignId: number) =>
  createSelector(
    (state: RootState) =>
      state.background.campaignIdViewCounts?.[campaignId]?.uniqueViews,
    (uniqueViews) => uniqueViews
  );
